import { render, staticRenderFns } from "./TransferHistory.vue?vue&type=template&id=74007e70"
import script from "./TransferHistory.vue?vue&type=script&lang=js"
export * from "./TransferHistory.vue?vue&type=script&lang=js"
import style0 from "./TransferHistory.vue?vue&type=style&index=0&id=74007e70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports